/*
 *==================================================
 * Licensed Materials - Property of HCL Technologies
 *
 * HCL Commerce
 *
 * (C) Copyright HCL Technologies Limited 2020
 *
 *==================================================
 */
import styled from "styled-components";

import Button from "./button";

const TextLink = styled(({ ...props }) => (
  <Button {...props} variant="text">
    {props.label}
  </Button>
))`
  ${({ theme }) => `
     color: ${theme.palette.primary.main};
     &.MuiButtonBase-root {
       
     font-weight: 400;
     }
   `}
`;

export default TextLink;
